import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CustomerService } from 'src/app/services/customer.service';
import { PosCreateCustomerModalModule } from 'src/app/shared/pos-create-customer-modal/pos-create-customer-modal.module';
import { PosCustomerTableModule } from 'src/app/shared/pos-customer-table/pos-customer-table.module';
import { PosEmployeeTableModule } from 'src/app/shared/pos-employee-table/pos-employee-table.module';
import { PosUpdateRtnFiscalIdModalModule } from 'src/app/shared/pos-update-rtn-fiscal-id-modal/pos-update-rtn-fiscal-id-modal.module';
import { CustomerStepComponent } from './customer-step.component';



@NgModule({
  declarations: [CustomerStepComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TabsModule,
    PosCustomerTableModule,
    PosEmployeeTableModule,
    PosUpdateRtnFiscalIdModalModule,
    PosCreateCustomerModalModule
  ],
  providers: [CustomerService],
  exports: [CustomerStepComponent]
})
export class CustomerStepModule { }
